import {request} from '@/util/request'

// IM WebSocket 配置
// 开发环境通过 vite proxy，生产环境使用当前页面的 host
const isDev = import.meta.env.DEV;
const devWsHost = 'ws://localhost:3000';
// 生产环境动态获取当前页面的 host，协议根据页面协议自动切换（http=>ws, https=>wss）
const getProdWsHost = () => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
};
export const WS_BASE = `${isDev ? devWsHost : getProdWsHost()}/webApi/moving/ws/im/chat`;

/***----------------ERP端IM接口---------- */
/** 
 * 发送聊天消息
 * @param {object} params 发送消息参数
 * @param {number} params.roomId 房间ID
 * @param {number} params.msgType 消息类型：0=系统 1=文字 2=图片 3=语音 4=商品 5=视频
 * @param {string} params.msg 消息内容（文字消息必填且被敏感词过滤；视频消息可为空）
 * @param {string} params.videoUrl 视频URL（msgType=5 时填）
 * @param {string} params.videoCover 视频封面URL（msgType=5 时填）
 * @param {number} params.videoDuration 视频时长（秒，msgType=5 时填）
 * @param {number} params.voiceDuration 语音时长（秒，msgType=3 时填）
 * @param {string} params.clientMsgId 客户端消息ID(前端生成UUID,单次发送(含重试/补发)复用同一个,用于幂等去重)
 * @returns
 */
export const sendMsgApi = (data) => {
  return request({
    url: '/webApi/pc/im/sendMsg',
    method: 'post',
    data
  })
}
/** 
 * 分页获取聊天记录
 * @param {object} params 房间消息分页参数
 * @param {number} params.roomId 房间ID
 * @param {number} params.page 页码（从1开始）
 * @param {number} params.size 每页条数
 * @returns
 */
export const getChatListApi = (data) => {
  return request({
    url: '/webApi/pc/im/roomMsgPage',
    method: 'post',
    data
  })
}

/** 
 * 获取客服房间列表
 * @returns
 */
export const getRoomListApi = (data) => {
  return request({
    url: '/webApi/pc/im/roomList',
    method: 'post',
    data: data
  })
}
/** 
 * 初始化房间或客服接单
 * @returns
 */
export const initRoomApi = (data) => {
  return request({
    url: '/webApi/pc/im/initRoom',
    method: 'post',
    data: data
  })
}
/** 
 * 按订单+对方角色进-建会话
 * @param {object} params 按订单+对方角色进/建单聊房间参数
 * @param {number} params.orderId 订单ID
 * @param {number} params.peerUserType 对方角色码(im_user_type)：1车主 2技师 3司机 4客服 5投资者
 * @returns
 */
export const enterOrderRoomApi = (data) => {
  return request({
    url: '/webApi/pc/im/enterOrderRoom',
    method: 'post',
    data: data
  })
}
/** 
 * 获取订单详情
 * @param {number} orderId 订单ID
 * @returns
 */
export const getOrderInfoApi = (orderId) => {
  return request({
    url: `/webApi/pc/im/orderInfo/${orderId}`,
    method: 'get',
  })
}
/**ERP端IM房间管理接口***/
/** 
 * 聊天室分页查询
 * @param {object} params ERP 房间分页查询参数
 * @param {number} params.page 页码（从1开始）
 * @param {number} params.size 每页条数
 * @param {number} params.roomType 房间类型筛选：1=单聊 2=客服 3=订单群
 * @param {number} params.roomStatus 房间状态筛选：1=待响应 2=聊天中 3=已结束
 * @returns
 */
export const imRoomPageApi = (data) => {
  return request({
    url: '/webApi/pc/im/room/page',
    method: 'post',
    data: data
  });
}

/** 
 * 强制关闭聊天室
 * @param {object} params 强制关闭房间参数
 * @param {number} params.roomId 房间ID
 * @param {string} params.reason 关闭原因（可选）
 * @returns
 */
export const forceCloseRoomApi = (data) => {
  return request({
    url: '/webApi/pc/im/room/forceClose',
    method: 'post',
    data: data
  });
}

/** 
 * 获取腾讯云 IM UserSig
 * @returns
 */
export const getImUserSigApi = () => {
  return request({
    url: '/webApi/pc/cim/getImUserSig',
    method: 'post'
  });
}
/** 
 * 根据订单获取需要聊天的对象
 * @param {object} params GetChatPeerParam
 * @param {number} params.orderId 订单ID
 * @param {string} params.peerUserType 对端用户类型,可用值:OWNER,TECHNICIAN,DRIVER,CUSTOMER_SERVICE,INVESTOR,STORE,SUPPLIER
 * @returns
 */
export function getChatToUserApi(params) {
  return request.post(`/webApi/pc/cim/getChatPeerUser`, params);
}
/** 
 * 分页查询会话列表
 * @param {object} params PageSessionParam
 * @param {number} params.page 
 * @param {number} params.size 
 * @param {number} params.orderId 
 * @returns
 */
export const getSessionListApi = (data) => {
  return request({
    url: '/webApi/pc/cim/session/page',
    method: 'post',
    data: data
  });
}

/** 
 * 获取最后一次聊天的oderId
 * @param {object} params GetLatestOrderIdParam
 * @param {string} params.peerCloudUserId 对端用户在云通信的用户ID
 * @returns
 */
export function getLatestOrderIdApi(params) {
  return request.post(`/webApi/pc/cim/orderId/latest`, params);
}

/** 
 * 分页查询会话列表
 * @param {object} params PageSessionParam
 * @param {number} params.page 
 * @param {number} params.size 
 * @param {number} params.orderId 
 * @returns
 */
export function pageSessionApi(params) {
  return request.post(`/webApi/pc/cim/session/page`, params);
}

/** 
 * 查询消息
 * @param {object} params PageMsgParam
 * @param {number} params.page 
 * @param {number} params.size 
 * @param {number} params.sessionId 
 * @returns
 */
export function sessionPageMsgApi(params) {
  return request.post(`/webApi/pc/cim/session/msg/page`, params);
}

// /** 
//  * 腾讯云IM回调
//  * @param {object} params TencentCallbackRequest
//  * @param {string} params.CallbackCommand 
//  * @param {string} params.From_Account 
//  * @param {string} params.To_Account 
//  * @param {string} params.Report_Account 
//  * @param {string} params.Peer_Account 
//  * @param {number} params.MsgSeq 
//  * @param {number} params.MsgTime 
//  * @param {string} params.MsgKey 
//  * @param {string} params.MsgId 
//  * @param {number} params.SendMsgResult 
//  * @param {array} params.MsgBody 
//  * @param {string} params.CloudCustomData 
//  * @returns
//  */
// export function handleTencentCallbackApi(params) {
//   return request.post(`/webApi/app/moving/vehicle/callback/tencent`, params);
// }